import { defineMessages, type MessageDescriptor } from "react-intl";

export const likert5Messages = defineMessages({
  verySatisfied: { id: "candidate.answer.likert.verySatisfied", defaultMessage: "Very Satisfied" },
  satisfied: { id: "candidate.answer.likert.satisfied", defaultMessage: "Satisfied" },
  neutral: { id: "candidate.answer.likert.neutral", defaultMessage: "Neutral" },
  unsatisfied: { id: "candidate.answer.likert.unsatisfied", defaultMessage: "Unsatisfied" },
  veryUnsatisfied: { id: "candidate.answer.likert.veryUnsatisfied", defaultMessage: "Very Unsatisfied" },
});

export const likert5ByChoice: { [choice: number]: MessageDescriptor } = {
  1: likert5Messages.verySatisfied,
  2: likert5Messages.satisfied,
  3: likert5Messages.neutral,
  4: likert5Messages.unsatisfied,
  5: likert5Messages.veryUnsatisfied,
};

export const Likert5Choices: { [choice: number]: string } = {
  1: likert5Messages.verySatisfied.defaultMessage,
  2: likert5Messages.satisfied.defaultMessage,
  3: likert5Messages.neutral.defaultMessage,
  4: likert5Messages.unsatisfied.defaultMessage,
  5: likert5Messages.veryUnsatisfied.defaultMessage,
};
